import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";

const MD_CLASSES =
  "prose prose-sm prose-invert max-w-none break-words " +
  "[&_h1]:text-xl [&_h1]:font-bold [&_h1]:mb-3 [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:mt-6 [&_h2]:mb-2 " +
  "[&_h3]:text-base [&_h3]:font-semibold [&_h3]:mt-4 [&_h3]:mb-1 [&_p]:leading-7 [&_p]:text-foreground/90 " +
  "[&_li]:leading-6 [&_a]:text-blue-400 [&_a]:break-all [&_strong]:text-foreground " +
  "[&_blockquote]:border-l-2 [&_blockquote]:border-border [&_blockquote]:pl-4 [&_blockquote]:text-muted-foreground";

/** Markdown as the studio shows it: tables scroll, links open in a new tab. `components` adds or replaces renderers (the ledger uses it for stage badges). */
export function Markdown({ children, className = "", components }: { children: string; className?: string; components?: Components }) {
  return (
    <div className={`${MD_CLASSES} ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          table: ({ node: _n, ...props }) => (
            <div className="my-3 overflow-x-auto rounded-lg border border-border">
              <table {...props} className="my-0 w-full text-xs" />
            </div>
          ),
          a: ({ node: _n, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer nofollow" />,
          ...components,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
